import classnames from 'classnames';
import React from 'react';

import {IconButton} from '@albert-io/atomic';

import {isSupplementAnchor} from '../engine/annotationAnchors';
import {NOTE_TOOLTIP_PROPS} from '../constants';
import type {Anchor} from '../types';

interface AnnotationNoteEditButtonProps {
  /** Names the control, or every note's pencil announces alike. */
  anchor: Anchor;
  isEditing: boolean;
  className?: string;
  onClick: () => void;
}

/** The pencil opening a note's editor, shared by the side panel and the margin peek. */
export default function AnnotationNoteEditButton({
  anchor,
  isEditing,
  className,
  onClick
}: AnnotationNoteEditButtonProps) {
  return (
    <IconButton
      icon='pencil'
      iconStyle='regular'
      label={
        isSupplementAnchor(anchor)
          ? 'Edit note on this supplement'
          : `Edit note on “${anchor.exact}”`
      }
      size='xs'
      tooltip='Edit'
      tooltipProps={NOTE_TOOLTIP_PROPS}
      aria-haspopup='dialog'
      aria-expanded={isEditing}
      className={classnames('shrink-0', className)}
      onClick={onClick}
    />
  );
}
